export default {
  SET_RESELLER_PAYMENTS: function (state, resellerPayments) {
    state.resellerPayments = resellerPayments;
  }
}
